var exports = {
  "p$": "DMChannelView.module__emptyState___elJtd2",
  "AI": "DMChannelView.module__emptyStateIcon___elJtd2",
  "vo": "DMChannelView.module__emptyStateTitle___elJtd2",
  "Li": "DMChannelView.module__emptyStateDescription___elJtd2",
  "fX": "DMChannelView.module__callParticipantsRow___elJtd2",
  "gN": "DMChannelView.module__compactCallParticipantsRow___elJtd2",
  "Gr": "DMChannelView.module__callParticipant___elJtd2",
  "Gj": "DMChannelView.module__callParticipantAvatar___elJtd2",
  "I9": "DMChannelView.module__callParticipantRinging___elJtd2",
  "rV": "DMChannelView.module__call-participant-ring-pulse___elJtd2",
  "Jn": "DMChannelView.module__callBanner___elJtd2",
  "nY": "DMChannelView.module__callBannerBody___elJtd2",
  "c7": "DMChannelView.module__callBannerResizable___elJtd2",
  "oo": "DMChannelView.module__callControlBarSection___elJtd2",
  "Pf": "DMChannelView.module__callControlBarInner___elJtd2",
  "tX": "DMChannelView.module__callControls___elJtd2",
  "pm": "DMChannelView.module__callBannerMobile___elJtd2",
  "h8": "DMChannelView.module__callBannerMobileLabel___elJtd2",
  "ZI": "DMChannelView.module__callControlsMobile___elJtd2",
  "IX": "DMChannelView.module__compactCallResizeHandle___elJtd2",
  "rF": "DMChannelView.module__compactCallResizePill___elJtd2",
};

module.exports = exports;
